
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";

// Component definition
export default defineComponent({
  name: "SiteTitle",
  setup() {
    // reference to the root element
    const siteTitleRef = ref<HTMLElement>();

    // resize handler
    // Add/Remove title column classes according to the threshold (30rem).
    const resize = () => {
      if (siteTitleRef.value) {
        const px1rem = parseFloat(
          getComputedStyle(document.documentElement).fontSize
        );
        const thresholdWidth = 30 * px1rem;
        const clientWidth = siteTitleRef.value?.clientWidth;
        if (clientWidth <= thresholdWidth) {
          siteTitleRef.value?.classList.add("double-row");
          siteTitleRef.value?.classList.remove("single-row");
        } else {
          siteTitleRef.value?.classList.add("single-row");
          siteTitleRef.value?.classList.remove("double-row");
        }
      }
    };

    onMounted(() => {
      resize();
      window.addEventListener("resize", resize);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", resize);
    });

    return {
      siteTitleRef
    };
  }
});
